import { useContext } from 'react';

import { PracticeModalContext } from './practice-modal-context';

export const usePracticeModal = () => {
  const context = useContext(PracticeModalContext);

  if (!context) {
    throw new Error('usePracticeModal must be used within a PracticeModalProvider.');
  }

  return context;
};
